import React from 'react';
import Navbar from '../../components/Navbar';

function TermsOfUse() {
    return (
        <div>
            <Navbar />
            <main className="container" style={{ padding: 'var(--spacing-xl) 0', maxWidth: '760px' }}>
                <h1 style={{ marginBottom: '0.5rem' }}>Terms of Use</h1>
                <p className="text-muted" style={{ marginBottom: '2rem' }}>Last updated: January 2025</p>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing and using the Learnly platform, you agree to be bound by these Terms of Use. If you do not agree with any of these terms, please do not use the platform.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>2. Use of the Platform</h2>
                    <p>Learnly is an e-learning platform designed to help students access courses, materials, and assessments. You agree to use the platform only for lawful educational purposes and in accordance with these terms.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>3. User Accounts</h2>
                    <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately of any unauthorised use.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>4. Intellectual Property</h2>
                    <p>All course content, materials, and resources on Learnly are the property of Jalusi Tech or their respective content creators. You may not reproduce, distribute, or create derivative works without express written permission.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>5. Modifications</h2>
                    <p>We reserve the right to modify these terms at any time. Continued use of the platform after changes constitutes acceptance of the updated terms.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>6. Contact</h2>
                    <p>For questions about these terms, please contact us at <a href="mailto:support@learnly.co.za">support@learnly.co.za</a>.</p>
                </section>
            </main>
        </div>
    );
}

export default TermsOfUse;
